import { Column, DataType, ForeignKey, Model, Table, BelongsTo, Unique } from 'sequelize-typescript'
import { PlataformaModel } from '../../plataforma/models/plataforma.model'

@Table({
  freezeTableName: true,
  modelName: 'tipo_mensaje',
  timestamps: false,
})
export class TipoMensajeModel extends Model {
  @Unique('nombre-plataforma')
  @Column({
    type: DataType.STRING(55),
    allowNull: false,
  })
  nombre!: 'default' | 'text' | 'image'

  @Unique('nombre-plataforma')
  @ForeignKey(() => PlataformaModel)
  @Column({
    type: DataType.INTEGER,
    allowNull: false,
  })
  plataformaId!: number

  @Column({
    type: DataType.JSON,
    allowNull: false,
  })
  configuracion!: any

  @Column({
    type: DataType.JSON,
    allowNull: false,
  })
  configuracionEnviar!: any

  @Column({
    type: DataType.STRING,
    allowNull: false,
  })
  aplicacionIdentificador!: string

  @Column({
    type: DataType.TINYINT,
    allowNull: false,
  })
  eliminado!: boolean

  @BelongsTo(() => PlataformaModel)
  plataforma!: PlataformaModel
}
